import { render, staticRenderFns } from "./BalanceGymComp.vue?vue&type=template&id=73002f70&scoped=true"
import script from "./BalanceGymComp.vue?vue&type=script&lang=js"
export * from "./BalanceGymComp.vue?vue&type=script&lang=js"
import style0 from "./BalanceGymComp.vue?vue&type=style&index=0&id=73002f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73002f70",
  null
  
)

/* custom blocks */
import block0 from "./BalanceGymComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports